export default "__VITE_ASSET__BsY$$g5E__"